export default __webpack_public_path__ + "static/media/IMG_1975.91954a0c.JPG";